// Imports

import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Grid } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Backdrop } from "@mui/material";
import { Container } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import ReactSelect from "react-select";

import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useAlert } from "react-alert";
import PrintIcon from "@mui/icons-material/Print";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import Tooltip from "@mui/material/Tooltip";
import Documents from "../Documents";
import Headroom from "react-headroom";
import Checkbox from "@mui/material/Checkbox";
import Card from "@mui/material/Card";
import { ToastContainer, toast } from "react-toastify";
import OSAPAGE from "../Osapage";
import DialogTitle from "@mui/material/DialogTitle";
import Prior_auth from "../Prior_auth";
import VOBPAGE1 from "../Vobpage1";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Moment from "moment";
import InputMask from "react-input-mask";
import logoLight from "../../assets/images/logo-removebg-preview.png";

import {
  Modal,
  Typography,
  TextField,
  Divider,
  NativeSelect,
  Autocomplete,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import AuthorizationRegistration from "../AuthorizationRegistration";
import "../Button.css";
import {
  ArrowDropDown,
  ArrowDropDownCircle,
  ImportExport,
} from "@mui/icons-material";
import Popover from "@mui/material/Popover";
import Tmdform from "../Tmdform";
import AuthorizationFormByCPT from "../AuthorizationFormByCPT";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useSelector } from "react-redux";

const Authorization = (props) => {
  document.title = "Authorization | LuxBilling";
  const rights = useSelector((state) => state.login.rights);

  // API Authanticatiion
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const [isAllPractics, setisAllPractics] = useState(false);
  const [patientID, setPatientID] = React.useState("");
  const [columnID, setColumnID] = React.useState("");
  const [columnIDTMD, setColumnIDTMD] = React.useState("");
  const [columnIDICD, setColumnIDICD] = React.useState("");
  const [AutpattientIcd, setAutpattientIcd] = React.useState("");
  const [AutpattientIcd1, setAutpattientIcd1] = React.useState("");
  const [approvedcpt, setapprovedcpt] = React.useState(false);
  const [typeOfprocedureCode1, settypeOfprocedureCode1] = useState("");

  const [tmdcolumnID, settmdColumnID] = React.useState("");
  const [AutpattientID, setAutpattientID] = React.useState("");
  const [patientId, setpatientId] = useState(
    props.PatientId !== undefined ? props.PatientId : 0
  );
  const testpateint = props.PatientName; // comes From patient Registration

  const [patientName, setPatientName] = React.useState("");
  const [patientNametmd, setPatientNametmd] = React.useState("");
  const [patientNameicd, setPatientNameicd] = React.useState("");
  const [patientNameicd1, setPatientNameicd1] = React.useState("");
  const [PatientdateTMD, setPatientdateTMD] = React.useState("");

  const [patientNamee, setPatientNamee] = React.useState("");
  const [AuthRegistration, setAuthRegistration] = React.useState(null);

  const [AutpattientID1, setAutpattientID1] = React.useState("");
  const [AuthRequestid, setAuthRequestid] = React.useState("");
  const [OsaRequestid, setOSARequestid] = React.useState("");
  const [HealthRequestid, setHealthRequestid] = React.useState("");
  const [LomnRequestid, setLomnRequestid] = React.useState("");

  const [Markaporoved, setMarkaporoved] = React.useState(false);
  const [dobAuth, setdobAuth] = React.useState("");
  const [dosValues, setDosValues] = useState([]);
  const [Refresh, setRefresh] = useState(false);
  const getData = (data) => {
    // Handle the data in the parent component
    // You can do additional processing or set state here
    // For example, setDosValues(data);
  };

  const alert = useAlert();

  const [isLoading, setLoading] = useState(false);

  // const validationSchema = Yup.object({
  //   firstName: Yup.string().required('First Name is required'),

  // })

  const [AuthRequest, setAuthRequest] = React.useState(false);
  const handleAuthRequest = () => {
    setAuthRequest(true);
  };
  const setAuthId = (_id) => {
    setColumnID(_id);
  };
  const handlecloseAuthRequestbutton = () => {
    setColumnID("");
    setAuthRequestid("");
    setPatientNamee("");

    setAuthRequest(false);
  };
  const [Submissiondate, setSubmissiondate] = useState("");
  const handlecloseAuthRequest = () => {
    setColumnID("");
    setAuthRequestid("");
    setPatientNamee("");

    //.
    const postData = AuthRegistration;
    postData.authRequest = true;
    postData.dateSubmission = Submissiondate
      ? Submissiondate
      : new Date().toISOString().split("T")[0];
    postData.cptCode = Charge1;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization?patientId=${patientID}`,
        postData,
        { headers }
      )

      .then((response) => {})
      .catch((error) => {
        // setdisable(true);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });

    setAuthRequest(false);
  };

  const [osaRequest, setOsaRequest] = React.useState(false);
  const handleOsaRequest = () => {
    setOsaRequest(true);
  };
  const handlecloseOsaRequest = () => {
    setColumnID("");
    setOSARequestid("");
    setPatientNamee("");
    // const postData = AuthRegistration
    const postData = {
      ...AuthRegistration,
      questionnaire: true, // This will overwrite any existing 'questionnaire' field
      cptCode: Charge1,
    };
    // postData.questionnaire = true;
    // postData.dateSubmission = new Date().toISOString().split('T')[0];
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization?patientId=${patientID}`,
        postData,
        { headers }
      )

      .then((response) => {})
      .catch((error) => {
        // setdisable(true);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
    setOsaRequest(false);
  };

  const handlecloseOsaRequestbutton = () => {
    setColumnID("");
    setOSARequestid("");
    setPatientNamee("");

    setOsaRequest(false);
  };
  const [healthRequest, setHealthRequest] = React.useState(false);
  const handleHealthRequest = () => {
    setHealthRequest(true);
  };
  const handlecloseHealthRequest = () => {
    setColumnID("");
    setHealthRequestid("");
    setPatientNamee("");
    const postData = AuthRegistration;
    postData.healthHistory = true;
    postData.cptCode = Charge1;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization?patientId=${patientID}`,
        postData,
        { headers }
      )

      .then((response) => {})
      .catch((error) => {
        // setdisable(true);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
    setHealthRequest(false);
  };

  const handlecloseHealthRequestbutton = () => {
    setColumnID("");
    setHealthRequestid("");
    setPatientNamee("");

    setHealthRequest(false);
  };

  const [lomnRequest, setLomnRequest] = React.useState(false);
  const handleLomnRequest = () => {
    setLomnRequest(true);
  };
  const handlecloseLomnRequest = () => {
    setColumnID("");
    setLomnRequestid("");
    setPatientNamee("");
    // const postData = AuthRegistration
    const postData = {
      ...AuthRegistration,
      lomn: true,
      cptCode: Charge1,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization?patientId=${patientID}`,
        postData,
        { headers }
      )

      .then((response) => {})
      .catch((error) => {
        // setdisable(true);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
    setLomnRequest(false);
  };

  const handlecloseLomnRequestbutton = () => {
    setColumnID("");
    setLomnRequestid("");
    setPatientNamee("");

    setLomnRequest(false);
  };
  ////cptopen
  const [approvecpt, setapprovecpt] = React.useState(false);
  const handleapprovecpt = () => {
    setapprovecpt(true);
  };
  const handlecloseapprovecpt = () => {
    setColumnIDICD("");
    setAutpattientIcd("");
    setPatientNameicd("");

    setapprovecpt(false);
  };
  ////
  const [approve, setapprove] = React.useState(false);
  const handleapprove = () => {
    setapprove(true);
  };

  const handlecloseapprove = () => {
    setColumnID("");
    setAutpattientID1("");
    setPatientNamee("");

    setapprove(false);
  };

  const fields = [
    "id",
    "dos",
    "patientId",
    "patientInfo",
    "healthHistory",
    "questionnaire",
    "progressNotes",
    "AuthRequest",
    "approved",
    "patientName",
    "procedureCode1",
  ];
  const defValues = {
    dos: "",
    patientId: 0,
    patientInfo: "",
    healthHistory: "",
    questionnaire: "",
    progressNotes: "",
    AuthRequest: "",
    approved: "",
    patientName: "",
    procedureCode1: "",
  };
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);
  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      id: Delbyid,
      inactive: true,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setrefresh(!refresh);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
    setrefreshcpt(true);
  };
  const handleDelete1 = (cell) => {
    // Perform your delete logic here
    const postData = {
      id: Delbyid,
      inactive: true,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientNote/AddAuthorizationFormByCPT`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setrefresh(!refresh);
        setrefreshcpt(true);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
  };
  //////cptudeeffect
  useEffect(() => {
    if (AutpattientIcd > 0 && patientNameicd.length > 0) {
      handleapprovecpt();
    }
  }, [AutpattientIcd, patientNameicd]);
  ////

  useEffect(() => {
    if (AutpattientID1 > 0 && patientNamee.length > 0) {
      handleapprove();
    }
  }, [AutpattientID1]);
  useEffect(() => {
    if (AuthRequestid > 0 && patientNamee.length > 0) {
      handleAuthRequest();
    }
  }, [AuthRequestid, patientNamee]);
  useEffect(() => {
    if (OsaRequestid > 0 && patientNamee.length > 0) {
      handleOsaRequest();
    }
  }, [OsaRequestid, patientNamee]);
  useEffect(() => {
    if (HealthRequestid > 0 && patientNamee.length > 0) {
      handleHealthRequest();
    }
  }, [HealthRequestid, patientNamee]);
  useEffect(() => {
    if (LomnRequestid > 0 && patientNamee.length > 0) {
      handleLomnRequest();
    }
  }, [LomnRequestid, patientNamee]);
  const [AuthPracticeId, setAuthPracticeId] = useState("");
  const [ApproveRequests, setApproveRequests] = useState("all");
  const statusOptions = [
    { value: "all", label: "All" }, // 'All' option with empty string value
    { value: "new", label: "🔴New" }, // 'All' option with empty string value
    { value: "not-submitted", label: "🚫Not Submitted" }, // 'All' option with empty string value
    { value: "pending", label: "🟠Pending" },
    { value: "NeedsFurtherProcessing", label: "🟣Needs Further Processing" },
    { value: "completed", label: "🟢Completed" },
    { value: "approved", label: "✅Approved" },
    { value: "un-approved", label: "❌Un Approved" },
    { value: "archived", label: "🔵Archived" },
  ];

  const handleStatusChange = (selectedOption) => {
    setApproveRequests(selectedOption.value);
  };
  const [CreatedDate, setCreatedDate] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");

  const columns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.3,
      minWidth: 100,
    },
    {
      field: "PatientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 1,
      minWidth: 150,
      renderCell: (cellValues) => (
        <Button
          size="small"
          variant="text"
          color="info"
          sx={{
            textTransform: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            justifyContent: "flex-start",
            minWidth: 0, // Prevent forcing large size
            padding: 0, // Remove extra spacing
          }}
          onClick={(event) => {
            setColumnID(cellValues.row.id);
            setAutpattientID(cellValues.row.patientId);
            setPatientName(cellValues.row.PatientName);
            setOpenModal(true);
          }}
        >{`${cellValues.row.PatientName}`}</Button>
      ),
    },
    {
      field: "patientInfo",
      headerClassName: "super-app-theme--header",
      headerName: "Patient Info",
      minWidth: 120,
      hide: false,
      renderCell: (params) =>
        params.row.patientInfo ? (
          <CheckIcon style={{ color: "green" }} />
        ) : (
          <ClearIcon style={{ color: "red" }} />
        ),
    },

    {
      field: "AuthRequest",
      headerClassName: "super-app-theme--header",
      headerName: "Auth Request",
      minWidth: 110,
      hide: false,

      renderCell: (cell) => {
        const row = cell.row;

        if (ApproveRequests === "new" && !row.AuthRequest) {
          return null;
        }
        const showTooltip = !cell.row.LOMN || !cell.row.questionnaire;

        const handleClick = () => {
          if (showTooltip) return; // Prevent click when tooltip should show

          setColumnID(cell.row.id);
          setAuthRequestid(cell.row.patientId);
          setPatientNamee(cell.row.PatientName);
          setMarkaporoved(cell.row.approved);
          setAuthRegistration(cell.row);
          setAuthPracticeId(cell.row.practiceId);
          setSubmissiondate(cell.row.dateSubmission);
        };

        if (row.AuthRequest) {
          return showTooltip ? (
            <Tooltip title="Please submit mandatory Box Information first">
              <span>
                <TaskAltIcon
                  onClick={handleClick}
                  style={{
                    color: "green",
                    cursor: "not-allowed",
                    opacity: 0.4,
                  }}
                />
              </span>
            </Tooltip>
          ) : (
            <TaskAltIcon
              onClick={handleClick}
              style={{
                color: "green",
                cursor: "pointer",
                opacity: 1,
              }}
            />
          );
        } else {
          return showTooltip ? (
            <Tooltip title="Please submit mandatory Box Info first">
              <span>
                <CancelOutlinedIcon
                  onClick={handleClick}
                  style={{
                    color: "red",
                    cursor: "not-allowed",
                    opacity: 0.4,
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                  }}
                />
              </span>
            </Tooltip>
          ) : (
            <CancelOutlinedIcon
              onClick={handleClick}
              style={{
                color: "red",
                cursor: "pointer",
                opacity: 1,
                marginRight: "5px",
                float: "right",
                marginTop: "5px",
              }}
            />
          );
        }
      },
    },
    // {
    //   field: isAllPractics == true ? "PracticeName" : "",
    //   headerName: isAllPractics == true ? "Practice Name" : "",
    //   headerClassName: "super-app-theme--header",
    //   cellClassName: isAllPractics == true ? "gridCell" : "",
    //   hide: false,
    //   minWidth: isAllPractics == true ? 180 : 10,
    //   sortable: false,
    //   // flex: isAllPractics == true ? 0.6 : '',
    // },
    {
      field: "questionnaire",
      headerClassName: "super-app-theme--header",
      headerName: "Questionnaire",
      flex: 0.7,
      minWidth: 120,
      renderCell: (cell) => {
        const isQuestionnairePresent = !!cell.row.questionnaire;

        return (
          <TaskAltIcon
            onClick={() => {
              setColumnID(cell.row.id);
              setOSARequestid(cell.row.patientId);
              setPatientNamee(cell.row.PatientName);
              setMarkaporoved(cell.row.approved);
              setAuthRegistration(cell.row);
              setSubmissiondate(cell.row.dateSubmission);
            }}
            style={{
              color: isQuestionnairePresent ? "green" : "red",
              cursor: "pointer",
              marginRight: "5px",
              float: "right",
              marginTop: "5px",
            }}
          />
        );
      },
    },

    // {
    //   field: "HealthHistory",
    //   headerClassName: "super-app-theme--header",
    //   headerName: "Health History",
    //   flex: 0.7,
    //   hide: false,
    //   // renderCell: (params ) =>
    //   // params.row.HealthHistory ? (
    //   //   <CheckIcon style={{ color: "green" }} />
    //   // ) : (
    //   //   <ClearIcon style={{ color: "red" }} />
    //   renderCell: (cell) => {
    //     if (cell.row.HealthHistory) {

    //       return (
    //         <TaskAltIcon
    //           onClick={(e) => {
    //             setColumnID(cell.row.id)
    //             setHealthRequestid(cell.row.patientId)
    //             setPatientNamee(cell.row.PatientName)
    //             setMarkaporoved(cell.row.approved)
    //             setAuthRegistration(cell.row)

    //             // handleapprove()
    //           }}
    //           style={{
    //             // marginRight: "5px",
    //             // float: "right",
    //             // marginTop: "5px",
    //             color: "green",

    //             // cursor: "not-allowed",
    //           }}></TaskAltIcon>
    //       );
    //     } else {
    //       // If approved is false, render the button that can be clicked
    //       return (
    //         <>

    //           <TaskAltIcon
    //             style={{
    //               marginRight: "5px",
    //               float: "right",
    //               marginTop: "5px",
    //               color: "red",
    //               cursor: "pointer",
    //             }}
    //             onClick={(cellValues) => {

    //               setColumnID(cell.row.id)
    //               setHealthRequestid(cell.row.patientId)
    //               setPatientNamee(cell.row.PatientName)
    //               setMarkaporoved(cell.row.approved)
    //               setAuthRegistration(cell.row)

    //             }}
    //           ></TaskAltIcon>
    //         </>
    //       );
    //     }
    //   },
    //   // ),

    // },

    {
      field: "LOMN",
      headerClassName: "super-app-theme--header",
      headerName: "LOMN",
      flex: 0.5,
      minWidth: 120,
      hide: false,
      // renderCell: (params) =>
      //   params.row.LOMN ? (
      //     <CheckIcon style={{ color: "green" }} />
      //   ) : (
      //     <ClearIcon style={{ color: "red" }} />
      //   ),
      renderCell: (cell) => {
        const isApproved = cell.row.LOMN; // Check the LOMN value

        return (
          <TaskAltIcon
            onClick={() => {
              setColumnID(cell.row.id);
              setLomnRequestid(cell.row.patientId);
              setPatientNamee(cell.row.PatientName);
              setAuthRegistration(cell.row);
              setSubmissiondate(cell.row.dateSubmission);
            }}
            style={{
              marginRight: "5px",
              float: "right",
              marginTop: "5px",
              color: isApproved ? "green" : "red", // Green if true, Red if false
              cursor: "pointer",
            }}
          />
        );
      },
    },

    // {
    //   field: "Approve",
    //   headerName: "View Approval",
    //   sortable: true,
    //   headerClassName: "super-app-theme--header",
    //   flex: 0.5,
    //   minWidth: 150,
    //   renderCell: (cell) => {
    //     return (
    //       <TaskAltIcon
    //         onClick={(e) => {
    //           setColumnID(cell.row.id)
    //           setAutpattientID1(cell.row.patientId)
    //           setPatientNamee(cell.row.PatientName)
    //           setMarkaporoved(cell.row.approved)
    //           setAuthPracticeId(cell.row.practiceId)
    //           setCreatedDate(cell.row.createdDate)
    //           setCreatedBy(cell.row.createdBy)
    //           setSubmissiondate(cell.row.dateSubmission)

    //           // handleapprove()
    //         }}
    //         style={{
    //           marginRight: "5px",
    //           float: "right",
    //           marginTop: "5px",
    //           color:
    //             ApproveRequests === 'new'|| ApproveRequests === 'not-submitted'
    //               ? 'red'
    //               : ApproveRequests === 'pending'
    //                 ? 'orange'
    //                 : ApproveRequests === 'completed' || ApproveRequests === 'approved' || ApproveRequests === 'un-approved'
    //                   ? 'green'
    //                   : ApproveRequests === 'NeedsFurtherProcessing'
    //                     ? 'purple'
    //                     : ApproveRequests === 'archived'
    //                       ? 'blue'
    //                       : ApproveRequests === 'all'
    //                         ? cell.row.StatusColor === 'Green'
    //                           ? 'green'
    //                           : cell.row.StatusColor === 'Red'
    //                             ? 'red'
    //                             : cell.row.StatusColor === 'purple'
    //                               ? 'purple'
    //                               : cell.row.StatusColor === 'Orange'
    //                                 ? 'orange'
    //                                 : cell.row.StatusColor === 'black'
    //                                   ? 'black'
    //                                   : cell.row.StatusColor === 'blue'
    //                                     ? 'blue'
    //                                     : ''
    //                         : ''

    //         }}></TaskAltIcon>
    //     );
    //   },
    // },
    {
      field: "Approve",
      headerName: "View Approval",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.5,
      minWidth: 150,
      renderCell: (cell) => {
     // 🟡 Conditions
    const isMissingBoxInfo =
      !cell.row.LOMN || !cell.row.questionnaire || !cell.row.AuthRequest;

const isLockedByRights =
  !rights?.Authoriazation_Lock_Completed_VOBs && cell.row.StatusColor === "Green"; 

    // 🔒 Overall disable flag
    const isDisabled = isMissingBoxInfo || isLockedByRights;

    // 🧾 Tooltip logic
    const tooltipMessage = isLockedByRights
      ? "Completed VOBs are locked🔒"
      : isMissingBoxInfo
      ? "Please submit mandatory Box Information first"
      : "";


        return (
          <Tooltip   title={tooltipMessage}
        arrow
        disableHoverListener={!isDisabled}>
            <span style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}>
              <TaskAltIcon
                onClick={(e) => {
                  if (isDisabled) return;

                  setColumnID(cell.row.id);
                  setAutpattientID1(cell.row.patientId);
                  setPatientNamee(cell.row.PatientName);
                  setMarkaporoved(cell.row.approved);
                  setAuthPracticeId(cell.row.practiceId);
                  setCreatedDate(cell.row.createdDate);
                  setCreatedBy(cell.row.createdBy);
                  setSubmissiondate(cell.row.dateSubmission);
                }}
                style={{
                  marginRight: "5px",
                  float: "right",
                  marginTop: "5px",
                  pointerEvents: isDisabled ? "none" : "auto",
                  opacity: isDisabled ? 0.5 : 1,
                  color:
                    ApproveRequests === "new" ||
                    ApproveRequests === "not-submitted"
                      ? "red"
                      : ApproveRequests === "pending"
                      ? "orange"
                      : ApproveRequests === "completed" ||
                        ApproveRequests === "approved" ||
                        ApproveRequests === "un-approved"
                      ? "green"
                      : ApproveRequests === "NeedsFurtherProcessing"
                      ? "purple"
                      : ApproveRequests === "archived"
                      ? "blue"
                      : ApproveRequests === "all"
                      ? cell.row.StatusColor === "Green"
                        ? "green"
                        : cell.row.StatusColor === "Red"
                        ? "red"
                        : cell.row.StatusColor === "purple"
                        ? "purple"
                        : cell.row.StatusColor === "Orange"
                        ? "orange"
                        : cell.row.StatusColor === "black"
                        ? "black"
                        : cell.row.StatusColor === "blue"
                        ? "blue"
                        : ""
                      : "",
                }}
              />
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "carrier",
      headerName: "Carrier", // Make sure this is correctly labeled
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      flex: 0.9,
      minWidth: 120,
      renderCell: (cell) => (
        <span>{cell.row.carrier ? cell.row.carrier : ""}</span> // Display value or fallback
      ),
    },
    ...(rights?.Delete_Authorization
      ? [
          {
            field: "delete",
            headerClassName: "super-app-theme--header",
            headerName: "Delete",
            minWidth: 100,
            align: "center",
            headerAlign: "center",
            renderCell: (cell) => {
              const row = cell.row;
              const userType = localStorage.getItem("User_Type");
              const isApproved = row.approved === true;
              const restrictedColors = ["orange", "blue", "purple"];
              const statusColor = row.StatusColor?.toLowerCase();
              const isRestrictedColor = restrictedColors.includes(statusColor);

              const isAuthRequest = row.AuthRequest === true;

              const isDisabled =
                userType?.toLowerCase() !== "admin" &&
                (isRestrictedColor || isApproved || isAuthRequest);

              return (
                <DeleteIcon
                  style={{
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                    color: isDisabled ? "#ccc" : "red",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                  // onClick={() => {
                  //   if (isDisabled) return; // do nothing if disabled

                  //   confirmAlert({
                  //     message: "Do you want to delete the record.",
                  //     closeOnEscape: true,
                  //     closeOnClickOutside: true,
                  //     overlayClassName: "custom-overlay-zindex",
                  //     buttons: [
                  //       {
                  //         label: "Yes",
                  //         onClick: () => {
                  //           const postData = { id: row.id, inactive: true };
                  //           axios
                  //             .post(
                  //               `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization`,
                  //               postData,
                  //               { headers }
                  //             )
                  //             .then(() => setrefresh(!refresh))
                  //             .catch((error) => {
                  //               console.error("There was an error!", error);
                  //             });
                  //         },
                  //       },
                  //       { label: "No" },
                  //     ],
                  //   });

                  //   setTimeout(() => {
                  //     const overlay = document.querySelector(
                  //       ".custom-overlay-zindex"
                  //     );
                  //     if (overlay) overlay.style.zIndex = 1800;
                  //     const dialog = document.querySelector(
                  //       ".react-confirm-alert"
                  //     );
                  //     if (dialog) dialog.style.zIndex = 1801;
                  //   }, 10);
                  // }}
                  onClick={() => {
  if (isDisabled) return; // ❌ disabled ho to kuch na kare

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to delete the record.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c7c84",
    heightAuto: false,
    backdrop: true,
    didOpen: () => {
      // ✅ z-index fix
      const popup = document.querySelector(".swal2-popup");
      const container = document.querySelector(".swal2-container");
      const backdrop = document.querySelector(".swal2-backdrop");

      if (popup) popup.style.zIndex = "1801";
      if (container) container.style.zIndex = "1801";
      if (backdrop) backdrop.style.zIndex = "1800";
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const postData = { id: row.id, inactive: true };

      axios
        .post(
          `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization`,
          postData,
          { headers }
        )
        .then(() => {
          setrefresh(!refresh);

          // ✅ optional success auto-close
          Swal.fire({
            title: "Deleted!",
            text: "Record deleted successfully.",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
            heightAuto: false,
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);

          Swal.fire({
            title: "Error!",
            text: "Something went wrong.",
            icon: "error",
            heightAuto: false,
          });
        });
    }
  });
}}

                />
              );
            },
          },
        ]
      : []),
  ];
  const [Delbyid1, setDelbyid1] = useState(false);

  const handleDeleteById1 = () => {
    const postData = {
      id: Delbyid1,
      inactive: true,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientNote/AddTMDisorders`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setrefresh(!refresh);
        setDialogOpen(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const tmdcolumns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      hide: false,
      sortable: false,
      flex: 0.1,
    },
    {
      field: "patientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      hide: false,
      sortable: false,
      flex: 0.3,
      renderCell: (cellValues) => (
        <Button
          size="small"
          variant="text"
          color="info"
          onClick={() => {
            setColumnIDTMD(cellValues.row.id);
            setAutpattientID(cellValues.row.patientId);
            setPatientNametmd(cellValues.row.patientName);
            setOpenModaltmd(true);
          }}
        >
          {cellValues.row.patientName}
        </Button>
      ),
    },
    {
      field: "dateTMD",
      headerName: "TMD Date",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      hide: false,
      sortable: false,
      flex: 0.3,
    },
    {
      field: isAllPractics == true ? "PracticeName" : "",
      headerName: isAllPractics == true ? "Practice Name" : "",
      headerClassName: "super-app-theme--header",
      cellClassName: isAllPractics == true ? "gridCell" : "",
      hide: false,
      sortable: false,
      flex: isAllPractics == true ? 0.3 : "",
    },
    ...(rights?.Delete_Authorization
      ? [
          {
            field: "inactive",
            headerClassName: "super-app-theme--header",
            headerName: "Delete",
            sortable: true,
            flex: 0.1,
            renderCell: (cell) => (
              <>
                <DeleteIcon
                  style={{
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  // onClick={(cellValues) => {
                  //   confirmAlert({
                  //     message: "Do you want to delete the record.",
                  //     closeOnEscape: true,
                  //     closeOnClickOutside: true,
                  //     overlayClassName: "overlay-custom-class-name",

                  //     buttons: [
                  //       {
                  //         label: "Yes",

                  //         onClick: () => {
                  //           const postData = {
                  //             id: cell.row.id,
                  //             inactive: true,
                  //           };

                  //           axios
                  //             .post(
                  //               `${process.env.REACT_APP_API_URL}/PatientNote/AddTMDisorders`,
                  //               postData,
                  //               {
                  //                 headers,
                  //               }
                  //             )
                  //             .then((response) => {
                  //               setrefresh(!refresh);
                  //               // setOpenNote(false)
                  //             })
                  //             .catch((error) => {
                  //               console.error("There was an error!", error);
                  //             });
                  //         },
                  //       },
                  //       {
                  //         label: "No",
                  //       },
                  //     ],
                  //   });
                  // }}
                  onClick={() => {

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to delete the record.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c7c84",
    heightAuto: false,
    backdrop: true,
    didOpen: () => {
      // ✅ z-index fix
      const popup = document.querySelector(".swal2-popup");
      const container = document.querySelector(".swal2-container");
      const backdrop = document.querySelector(".swal2-backdrop");

      if (popup) popup.style.zIndex = "1801";
      if (container) container.style.zIndex = "1801";
      if (backdrop) backdrop.style.zIndex = "1800";
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const postData = { id: cell.row.id, inactive: true };

      axios
        .post(
          `${process.env.REACT_APP_API_URL}/PatientNote/AddTMDisorders`,
          postData,
          { headers }
        )
        .then(() => {
        setrefresh(!refresh);

          // ✅ optional success auto-close
          Swal.fire({
            title: "Deleted!",
            text: "Record deleted successfully.",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
            heightAuto: false,
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);

          Swal.fire({
            title: "Error!",
            text: "Something went wrong.",
            icon: "error",
            heightAuto: false,
          });
        });
    }
  });
}}

                ></DeleteIcon>
              </>
            ),
          },
        ]
      : []),
  ];

  const cptcolumns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.1,
    },
    {
      field: "patientName",
      headerName: "PatientName",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.4,
      renderCell: (cellValues) => (
        <Button
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setColumnIDICD(cellValues.row.id);
            // setAutpattientIcd(cellValues.row.patientId)
            setAutpattientIcd1(cellValues.row.patientId);
            setapprovedcpt(cellValues.row.approved);
            setPatientNameicd1(cellValues.row.patientName);
            setAuthPracticeId(cellValues.row.practiceId);
            setCreatedDate(cellValues.row.createdDate);
            setCreatedBy(cellValues.row.createdBy);
            setSubmissiondate(cellValues.row.dateSubmission);
            // setPatientNameicd(cellValues.row.patientName)
            setOpenModalicd(true);

            // opentmdRegistration(event,cellValues.row.id)
            // setAutpattientID(cellValues.row.patientId)
            // setPatientName(cellValues.row.PatientName)
            // setOpenModal(true)
          }}
        >{`${cellValues.row.patientName}`}</Button>
      ),
    },
    {
      field: "cptcode",
      headerName: "Cpt Code",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.3,
    },
    {
      field: "cptcharges",
      headerName: "Charges",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.3,
    },
    {
      field: isAllPractics == true ? "PracticeName" : "",
      headerName: isAllPractics == true ? "Practice Name" : "",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: isAllPractics == true ? 0.3 : "",
    },
    {
      field: "dateofSubmission",
      headerName: "Date of Submission",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.3,
    },

    {
      field: "approve",
      headerName: "Approve",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      renderCell: (cell) => {
        return (
          <TaskAltIcon
            onClick={(e) => {
              setColumnIDICD(cell.row.id);
              setAutpattientIcd(cell.row.patientId);
              setPatientNameicd(cell.row.patientName);
              setMarkaporoved(cell.row.approved);
              setAuthPracticeId(cell.row.practiceId);
              setCreatedDate(cell.row.createdDate);
              setCreatedBy(cell.row.createdBy);
              setSubmissiondate(cell.row.dateSubmission);
              // handleapprove()
            }}
            style={{
              marginRight: "5px",
              float: "right",
              marginTop: "5px",
              color:
                ApproveRequests === "new"
                  ? "red"
                  : ApproveRequests === "pending"
                  ? "orange"
                  : ApproveRequests === "completed" ||
                    ApproveRequests === "approved" ||
                    ApproveRequests === "un-approved"
                  ? "green"
                  : ApproveRequests === "NeedsFurtherProcessing"
                  ? "purple"
                  : ApproveRequests === "archived"
                  ? "blue"
                  : ApproveRequests === "all"
                  ? cell.row.StatusColor === "Green"
                    ? "green"
                    : cell.row.StatusColor === "Red"
                    ? "red"
                    : cell.row.StatusColor === "purple"
                    ? "purple"
                    : cell.row.StatusColor === "Orange"
                    ? "orange"
                    : cell.row.StatusColor === "black"
                    ? "black"
                    : cell.row.StatusColor === "blue"
                    ? "blue"
                    : ""
                  : "",
              // cursor: "not-allowed",
            }}
          ></TaskAltIcon>
        );
      },
    },
    ...(rights?.Delete_Authorization
      ? [
          {
            field: "delete",
            headerClassName: "super-app-theme--header",
            headerName: "Delete",
            flex: 0.3,
            align: "center",
            headerAlign: "center",
            renderCell: (cell) => (
              <>
                <DeleteIcon
                  style={{
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                    color: "red",
                    cursor: "pointer",
                  }}
                             onClick={() => {

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to delete the record.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c7c84",
    heightAuto: false,
    backdrop: true,
    didOpen: () => {
      // ✅ z-index fix
      const popup = document.querySelector(".swal2-popup");
      const container = document.querySelector(".swal2-container");
      const backdrop = document.querySelector(".swal2-backdrop");

      if (popup) popup.style.zIndex = "1801";
      if (container) container.style.zIndex = "1801";
      if (backdrop) backdrop.style.zIndex = "1800";
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const postData = { id: cell.row.id, inactive: true };

      axios
        .post(
          `${process.env.REACT_APP_API_URL}/PatientNote/AddAuthorizationFormByCPT`,
          postData,
          { headers }
        )
        .then(() => {
        setrefresh(!refresh);

          // ✅ optional success auto-close
          Swal.fire({
            title: "Deleted!",
            text: "Record deleted successfully.",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
            heightAuto: false,
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);

          Swal.fire({
            title: "Error!",
            text: "Something went wrong.",
            icon: "error",
            heightAuto: false,
          });
        });
    }
  });
}}

                ></DeleteIcon>
              </>
            ),
          },
        ]
      : []),
  ];
  const [submitting, setSubmitting] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  // Define Variables
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [tmdrows, setTmdrows] = useState(null);
  const [Cptsrows, setCptsrows] = useState(null);

  const [rowsID, setRowsID] = useState(null);
  const [refresh, setrefresh] = useState(false);
  const [refreshtmd, setrefreshtmd] = useState(false);
  const [refreshcpt, setrefreshcpt] = useState(false);

  const [patientSelected, setPatientSelected] = React.useState(false);
  const [patientData, setPatientData] = React.useState([]);
  const [patient, setPatient] = React.useState(false);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [error, seterror] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [cellid, setcellid] = useState("");
  const [Dos, setDos] = useState("");
  const UserTypes = localStorage.getItem("User_Type");
  const FormCall = props.FormCall;
  const handleClickOpen = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleDeleteById = () => {
    const postData = {
      id: cellid,
      deleted: true,
      patientId: patientID,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setrefresh(!refresh);
        setOpenAlert(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  // useEffect(() => {
  //   handleOpen()
  // }, [columnID])
  // API's Calling
  const [DateofSubmission, setDateofSubmission] = useState("");
  useEffect(() => {
    if (columnID > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/AutherizationRequest/AuthoorizationById?Id=${columnID}`,
          { headers }
        )
        .then((response) => {
          fields.forEach((field) => {
            setValue(field, response[field]);
          });
          setDateofSubmission(response.dateSubmission);
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [columnID]);
  const [Charge1, setCharge1] = useState("E0486");

 useEffect(() => {
  setLoading(true);

  axios
    .get(
      `${process.env.REACT_APP_API_URL}/AutherizationRequest/Authoorization?patientId=${patientId}&showAllPractices=${isAllPractics}&status=${ApproveRequests}`,
      { headers }
    )
    .then((response) => {
      if (response) {
        let filteredRows = response;

        // Filter for 'new' status to show only records with AuthRequest: true
        if (ApproveRequests === "new") {
          filteredRows = response.filter((item) => item.AuthRequest === true);
        }
        if (ApproveRequests === "approved") {
          filteredRows = response.filter((item) => item.approved === true);
        }

        setRows(filteredRows);
        const dosValues = filteredRows.map((item) => item.patientId);
        setRowsID(filteredRows.id);
        setLoading(false);
        setDos(dosValues);
        props.getData1(dosValues);
      }

      setLoading(false);
    })
    .catch((error) => {
      console.error("There was an error!", error);
      setLoading(false);
    });
}, [
  refresh,
  lomnRequest,
  OsaRequestid,
  AuthRequestid,
  typeOfprocedureCode1,
  isAllPractics,
  Charge1,
  ApproveRequests,
]);

  useEffect(() => {
    if (typeOfprocedureCode1 !== "21085") {
      return;
    }
    setLoading(true);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientNote/TMDisorders?patientId=${patientId}&showAllPractices=${isAllPractics}`,
        {
          headers,
        }
      )
      .then((response) => {
        setTmdrows(response);
        // setRowsID(response.id);
        setLoading(false);
        // setrefresh(!refresh)
      })

      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, [refreshtmd, refresh, typeOfprocedureCode1, isAllPractics]);
  // const [procedureCode1ID, setProcedureCode1ID] = useState("");

  useEffect(() => {
    if (Charge1.length > 0 || patientId > 0) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientNote/AuthorizationFormByCPT?patientId=${patientId}&cptcode=${Charge1}&showAllPractices=${isAllPractics}&status=${ApproveRequests}`,
          {
            headers,
          }
        )
        .then((response) => {
          setCptsrows(response);
          // setRowsID(response.id);
          setLoading(false);
          // setrefresh(!refresh)
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [refreshcpt, Charge1, columnIDICD, isAllPractics, ApproveRequests]);

  const onChangeHandle = async (value) => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setOptions
    const sendData = {
      id: value.patientId,
      lastName: "",
      firstName: value,
      ssn: "",
      status: "",
      cellPhone: "",
      address: "",
      dob: "",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        sendData,
        { headers },
        setPatientSelected(true)
      )
      .then((response) => {
        setPatientData(response);
        setPatient(true);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const handleInputChange = (event, newValue) => {
    const trimmedValue = newValue.trim();
    if (trimmedValue.length > 0) {
      onChangeHandle(trimmedValue);
    }
  };
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // Filter patientData to remove the selected patient
    if (selectedPatient) {
      setFilteredOptions(
        patientData.filter(
          (option) =>
            option.firstName !== selectedPatient.firstName ||
            option.lastName !== selectedPatient.lastName
        )
      );
    } else {
      // If no patient is selected, show all options
      setFilteredOptions(patientData);
    }
  }, [selectedPatient, patientData]);

  const handleOptionChange = (event, value) => {
    setSelectedPatient(value);
    setPatientID(value.id);
  };

  // Add new Modal Code

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    applyRefresh();
    setOpenModal(false);
  };

  const handleOpen1 = (value) => {
    reset();
    setOpenModal(true);
    setColumnID(0);
    setColumnIDTMD(0);
    setColumnIDICD(0);

    if (testpateint == "" && patientName != "") {
      setPatientName("");
    } else {
      setPatientName(testpateint);
    }
  };
  const [openModalicd, setOpenModalicd] = useState(false);
  const handleCloseModalicd = () => {
    applyRefreshcpt();
    setOpenModalicd(false);
  };

  const handleOpenicd = (value) => {
    reset();
    setOpenModalicd(true);
    setColumnIDICD(0);
    // setAutpattientIcd(0)
    if (testpateint == "" && patientNameicd1 != "") {
      setPatientNameicd1("");
    } else {
      setPatientNameicd1(testpateint);
    }
  };

  const [openModaltmd, setOpenModaltmd] = useState(false);
  const handleCloseModaltmd = () => {
    applyRefreshtmd();
    setOpenModaltmd(false);
  };

  const handleOpentmd = (value) => {
    reset();
    setOpenModaltmd(true);
    setColumnIDTMD(0);

    if (testpateint == "" && patientNametmd != "") {
      setPatientNametmd("");
    } else {
      setPatientNametmd(testpateint);
    }
  };
  function applyRefresh() {
    setrefresh(!refresh);
    setrefreshtmd(!refreshtmd);
    setrefreshcpt(!refreshcpt);
  }
  function applyRefreshtmd() {
    setrefreshtmd(!refreshtmd);
  }
  function applyRefreshcpt() {
    setrefreshcpt(!refreshcpt);
  }

  // Styling

  const doccheckstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
  };
  const [type, settype] = useState("");

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "drak",
    minHeight: "10px",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
      lineHeight: "20px",
    },
    "& .MuiDataGrid-colCell": {
      lineHeight: "20px", // Adjust this value to decrease the header height
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const checkstyle1 = {
    position: "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #356F60",
    boxShadow: 24,
    // overflow: "auto",
    // overflow: "auto",
    /* Other styles */
    scrollbarWidth: "thin", // For Firefox
    scrollbarColor: "#356F60 transparent", // thumb color and track color
    "&::-webkit-scrollbar": {
      width: 8 /* Width of vertical scrollbar */,
      height: 8 /* Height of horizontal scrollbar */,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60" /* Color of the thumb */,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent" /* Color of the track */,
    },
    /* Adjust the width for the horizontal scrollbar */
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4 /* Width of horizontal scrollbar */,
    },
    // zIndex: "10",
  };
  const [Charge, setCharge] = useState("");
  const [procedureCode1ID, setProcedureCode1ID] = useState("E0486");

  const [procedureCode1List, setProcedureCode1List] = useState([]);

  useEffect(() => {
    // POST request using axios inside useEffect React hook
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: `${field.code}-${field.description}`,
            value: field.code,
            qasim: field.code,
            charges: field.default_charges,
          });
        });
        setProcedureCode1List(prac);
      })
      .catch((error) => {});
  }, []);
  const [selectedValue, setSelectedValue] = useState("current Month");
  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
  };

  return (
    <>
      <Modal
        open={lomnRequest}
        onClose={handlecloseLomnRequest}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true}
        title={"Title"}
       sx={{ zIndex: patientId && patientId > 0 ? 1750 : 1600 }}
      >
        <Box sx={doccheckstyle}>
          <Grid container spacing={1}>
            <Grid item xs={11} style={{ fontWeight: 500, marginTop: "10px" }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  marginLeft: "5px",
                  fontSize: "18px",
                  color: "white",
                  backgroundColor: "#377562",
                }}
              >
                Add patient document
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Button
                onClick={handlecloseLomnRequestbutton}
                variant="gradient"
                // disabled={submitting}
                style={{
                  marginTop: "10px",
                  float: "right",
                  marginBottom: "5px",
                  // width: "80px",
                  height: "35px",
                  backgroundColor: "#fff",
                  color: "black",
                  fontSize: "14px",
                  cursor: "pointer",
                }}

                // startIcon={<img src={SaveIcon} style={{marginTop:'-3px',marginRight:'-6px',}}/>}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{
                    color: "red",

                    paddingBottom: "2px",
                  }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} xl={12}>
            <Card
              bordered={false}
              style={{
                overflow: "auto",
                /* Other styles */
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#356F60 transparent", // thumb color and track color
                "&::-webkit-scrollbar": {
                  width: 8 /* Width of vertical scrollbar */,
                  height: 8 /* Height of horizontal scrollbar */,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#356F60" /* Color of the thumb */,
                  borderRadius: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent" /* Color of the track */,
                },
                /* Adjust the width for the horizontal scrollbar */
                "&::-webkit-scrollbar-thumb:horizontal": {
                  width: 4 /* Width of horizontal scrollbar */,
                },
                // zIndex: "10",

                height: "80vh",
              }}
            >
              <Documents
                callingFrom={"HealthRequest"}
                type={"lomn"}
                columnID={columnID}
                handleClose222={handlecloseLomnRequest}
                patientName={patientNamee}
                AutpattientID={LomnRequestid}
                updateHealthHistory={(id, authId) => {
                  setValue("lomn", true);
                  setColumnID(authId);
                  // setapproveid(authId)
                }}
                style={{ height: "40vh" }}
              ></Documents>
            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={healthRequest}
        onClose={handlecloseHealthRequest}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true}
        title={"Title"}
        sx={{ zIndex: 1700 }}
      >
        <Box sx={doccheckstyle}>
          <Grid container spacing={1}>
            <Grid item xs={11} style={{ fontWeight: 500, marginTop: "10px" }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  marginLeft: "5px",
                  fontSize: "18px",
                  color: "white",
                  backgroundColor: "#377562",
                }}
              >
                Add patient document
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Button
                onClick={handlecloseHealthRequestbutton}
                variant="gradient"
                // disabled={submitting}
                style={{
                  marginTop: "10px",
                  float: "right",
                  marginBottom: "5px",
                  // width: "80px",
                  height: "35px",
                  backgroundColor: "#fff",
                  color: "black",
                  fontSize: "14px",
                  cursor: "pointer",
                }}

                // startIcon={<img src={SaveIcon} style={{marginTop:'-3px',marginRight:'-6px',}}/>}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{
                    color: "red",

                    paddingBottom: "2px",
                  }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} xl={12}>
            <Card
              bordered={false}
              style={{
                overflow: "auto",
                /* Other styles */
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#356F60 transparent", // thumb color and track color
                "&::-webkit-scrollbar": {
                  width: 8 /* Width of vertical scrollbar */,
                  height: 8 /* Height of horizontal scrollbar */,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#356F60" /* Color of the thumb */,
                  borderRadius: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent" /* Color of the track */,
                },
                /* Adjust the width for the horizontal scrollbar */
                "&::-webkit-scrollbar-thumb:horizontal": {
                  width: 4 /* Width of horizontal scrollbar */,
                },
                // zIndex: "10",

                height: "80vh",
              }}
            >
              <Documents
                callingFrom={"HealthRequest"}
                type={"healthHistory"}
                columnID={columnID}
                handleClose222={handlecloseHealthRequest}
                patientName={patientNamee}
                AutpattientID={HealthRequestid}
                updateHealthHistory={(id, authId) => {
                  setValue("healthHistory", true);
                  setColumnID(authId);
                  // setapproveid(authId)
                }}
                style={{ height: "40vh" }}
              ></Documents>
            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={AuthRequest}
        onClose={handlecloseAuthRequest}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true}
        title={"Title"}
    sx={{ zIndex: patientId && patientId > 0 ? 1750 : 1600 }}
      >
        <Box sx={checkstyle1}>
          <Headroom>
            <Grid
              container
              border={2}
              // borderRadius={1}
              borderColor="#3C7F6B"
              style={{ backgroundColor: "white", position: "sticky" }}
            >
              <Grid item xs={12} sm={12} xl={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "3rem",
                  }}
                >
                  {/* <Grid container spacing={1}>
                        <Grid item xs={1} sm={1} xl={1}>

                        </Grid>
                      </Grid> */}
                  <img
                    src={logoLight}
                    alt="logo-light"
                    style={{ width: "4%", marginLeft: "5px" }}
                  />

                  <DialogTitle
                    style={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "black",
                        // textDecoration: 'underline',
                        fontSize: "1.5rem",
                      }}
                    >
                      VOB/ Prior-auth Request
                    </h1>
                  </DialogTitle>
                  <Typography style={{ color: "black", marginRight: "10px" }}>
                    Patient Name:
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      marginRight: "60px",
                    }}
                  >
                    {patientNamee}
                  </Typography>

                  <Typography style={{ color: "black", marginRight: "10px" }}>
                    ID:
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      marginRight: "60px",
                    }}
                  >
                    {columnID}
                  </Typography>

                  <CancelOutlinedIcon
                    onClick={handlecloseAuthRequestbutton}
                    fontSize="large"
                    color="red"
                    style={{
                      color: "red",
                      paddingRight: "5px",
                      cursor: "pointer",
                      // marginLeft: 'auto',
                      // marginRight: '1.5rem'
                    }}
                  ></CancelOutlinedIcon>
                </div>
              </Grid>
            </Grid>
          </Headroom>

          <Grid item xs={12} sm={12} xl={12}>
            <Card
              bordered={false}
              style={{
                overflow: "auto",
                /* Other styles */
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#356F60 transparent", // thumb color and track color
                "&::-webkit-scrollbar": {
                  width: 8 /* Width of vertical scrollbar */,
                  height: 8 /* Height of horizontal scrollbar */,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#356F60" /* Color of the thumb */,
                  borderRadius: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent" /* Color of the track */,
                },
                /* Adjust the width for the horizontal scrollbar */
                "&::-webkit-scrollbar-thumb:horizontal": {
                  width: 4 /* Width of horizontal scrollbar */,
                },
                // zIndex: "10",

                height: "80vh",
              }}
            >
              <VOBPAGE1
                callingFrom={"AuthRequest"}
                columnID={columnID}
                AuthPracticeId={AuthPracticeId}
                handleClose3={handlecloseAuthRequest}
                AuthRequestpatientName={patientNamee}
                AutpattientID={AuthRequestid}
                 setResetTab={props.setResetTab}
                   ResetTab={props.ResetTab}
                Markaporoved={Markaporoved}
                updateHealthHistory={(id, authId) => {
                  // setValue('AuthRequest', true)
                  setColumnID(authId);
                  // setapproveid(authId)
                }}
                style={{ height: "40vh" }}
              ></VOBPAGE1>
            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={osaRequest}
        onClose={handlecloseOsaRequest}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true}
        title={"Title"}
        sx={{ zIndex: patientId && patientId > 0 ? 1750 : 1600 }}
      >
        <Box sx={checkstyle1}>
          <Headroom>
            <Grid
              container
              border={2}
              // borderRadius={1}
              borderColor="#3C7F6B"
              style={{ backgroundColor: "white", position: "sticky" }}
            >
              <Grid item xs={12} sm={12} xl={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "3rem",
                  }}
                >
                  {/* <Grid container spacing={1}>
                        <Grid item xs={1} sm={1} xl={1}>

                        </Grid>
                      </Grid> */}
                  <img
                    src={logoLight}
                    alt="logo-light"
                    style={{ width: "4%", marginLeft: "5px" }}
                  />

                  <DialogTitle
                    style={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "black",
                        // textDecoration: 'underline',
                        fontSize: "2rem",
                      }}
                    >
                      Snoring and obstructive sleep apnea (OSA) Screener{" "}
                    </h1>
                  </DialogTitle>

                  <CancelOutlinedIcon
                    onClick={handlecloseOsaRequestbutton}
                    fontSize="large"
                    color="red"
                    style={{
                      color: "red",
                      paddingRight: "5px",
                      cursor: "pointer",
                      // marginLeft: 'auto',
                      // marginRight: '1.5rem'
                    }}
                  ></CancelOutlinedIcon>
                </div>
              </Grid>
            </Grid>
          </Headroom>

          <Grid item xs={12} sm={12} xl={12}>
            <Card
              bordered={false}
              style={{
                overflow: "auto",
                /* Other styles */
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#356F60 transparent", // thumb color and track color
                "&::-webkit-scrollbar": {
                  width: 8 /* Width of vertical scrollbar */,
                  height: 8 /* Height of horizontal scrollbar */,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#356F60" /* Color of the thumb */,
                  borderRadius: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent" /* Color of the track */,
                },
                /* Adjust the width for the horizontal scrollbar */
                "&::-webkit-scrollbar-thumb:horizontal": {
                  width: 4 /* Width of horizontal scrollbar */,
                },
                // zIndex: "10",

                height: "80vh",
              }}
            >
              <OSAPAGE
                callingFrom={"OSARequest"}
                columnID={columnID}
                handleClose1={handlecloseOsaRequest}
                OSARequestpatientName={patientNamee}
                AutpattientID={OsaRequestid}
                Markaporoved={Markaporoved}
                updateHealthHistory={(id, authId) => {
                  setValue("questionnaire", true);
                  setColumnID(authId);
                  // setapproveid(authId)
                }}
                style={{ height: "40vh" }}
              ></OSAPAGE>
            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={approve}
        onClose={handlecloseapprove}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true}
        title={"Title"}
        sx={{ zIndex: patientId && patientId > 0 ? 1750 : 1600 }}
      >
        <Box sx={checkstyle1}>
          <Headroom>
            <Grid
              container
              border={2}
              // borderRadius={1}
              borderColor="#3C7F6B"
              style={{ backgroundColor: "white", position: "sticky" }}
            >
              <Grid item xs={12} sm={12} xl={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "3rem",
                  }}
                >
                  {/* <Grid container spacing={1}>
                        <Grid item xs={1} sm={1} xl={1}>

                        </Grid>
                      </Grid> */}
                  <img
                    src={logoLight}
                    alt="logo-light"
                    style={{ width: "4%", marginLeft: "5px" }}
                  />

                  <DialogTitle
                    style={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "black",
                        // textDecoration: 'underline',
                        fontSize: "2rem",
                      }}
                    >
                      Prior-auth & VOB
                    </h1>
                  </DialogTitle>
                  <Typography style={{ color: "black", marginRight: "10px" }}>
                    Patient Name:
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      marginRight: "60px",
                    }}
                  >
                    {patientNamee}
                  </Typography>

                  <Typography style={{ color: "black", marginRight: "10px" }}>
                    ID:
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      marginRight: "60px",
                    }}
                  >
                    {columnID}
                  </Typography>

                  <CancelOutlinedIcon
                    onClick={handlecloseapprove}
                    fontSize="large"
                    color="red"
                    style={{
                      color: "red",
                      paddingRight: "5px",
                      cursor: "pointer",
                      // marginLeft: 'auto',
                      // marginRight: '1.5rem'
                    }}
                  ></CancelOutlinedIcon>
                </div>
              </Grid>
            </Grid>
          </Headroom>

          <Grid item xs={12} sm={12} xl={12}>
            <Card
              bordered={false}
              style={{
                overflow: "auto",
                /* Other styles */
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#356F60 transparent", // thumb color and track color
                "&::-webkit-scrollbar": {
                  width: 8 /* Width of vertical scrollbar */,
                  height: 8 /* Height of horizontal scrollbar */,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#356F60" /* Color of the thumb */,
                  borderRadius: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent" /* Color of the track */,
                },
                /* Adjust the width for the horizontal scrollbar */
                "&::-webkit-scrollbar-thumb:horizontal": {
                  width: 4 /* Width of horizontal scrollbar */,
                },
                // zIndex: "10",

                height: "80vh",
              }}
            >
              <Prior_auth
                Dos={Dos}
                callingFromAuthoriazation={"AUTH"}
                Source={"Authoorization"}
                Charge1={Charge1}
                PriorPracticeID={AuthPracticeId}
                CreatedDate={CreatedDate}
                CreatedBy={CreatedBy}
                columnID={columnID}
                PatientIdOfdemographics={patientId}
                DateofSubmission={Submissiondate}
                handleClose4={handlecloseapprove}
                patientNameee={patientNamee}
                AutpattientID1={AutpattientID1}
                Markaporoved={Markaporoved}
                updateHealthHistory={(id, authId) => {
                  setValue("approved", true);
                  setColumnID(authId);
                  // setapproveid(authId)
                }}
                style={{ height: "40vh" }}
              ></Prior_auth>
            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Grid>
        </Box>
      </Modal>

      {/* ///// modal Cpt open */}
      <Modal
        open={approvecpt}
        onClose={handlecloseapprovecpt}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true}
        title={"Title"}
        sx={{ zIndex: 1700 }}
      >
        <Box sx={checkstyle1}>
          <Headroom>
            <Grid
              container
              border={2}
              // borderRadius={1}
              borderColor="#3C7F6B"
              style={{ backgroundColor: "white", position: "sticky" }}
            >
              <Grid item xs={12} sm={12} xl={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "3rem",
                  }}
                >
                  {/* <Grid container spacing={1}>
                        <Grid item xs={1} sm={1} xl={1}>

                        </Grid>
                      </Grid> */}
                  <img
                    src={logoLight}
                    alt="logo-light"
                    style={{ width: "4%", marginLeft: "5px" }}
                  />

                  <DialogTitle
                    style={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "black",
                        // textDecoration: 'underline',
                        fontSize: "2rem",
                      }}
                    >
                      Prior-auth & VOB
                    </h1>
                  </DialogTitle>
                  <Typography style={{ color: "black", marginRight: "10px" }}>
                    Patient Name:
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      marginRight: "60px",
                    }}
                  >
                    {patientNameicd}
                  </Typography>

                  <Typography style={{ color: "black", marginRight: "10px" }}>
                    ID:
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      marginRight: "60px",
                    }}
                  >
                    {columnIDICD}
                  </Typography>

                  <CancelOutlinedIcon
                    onClick={handlecloseapprovecpt}
                    fontSize="large"
                    color="red"
                    style={{
                      color: "red",
                      paddingRight: "5px",
                      cursor: "pointer",
                      // marginLeft: 'auto',
                      // marginRight: '1.5rem'
                    }}
                  ></CancelOutlinedIcon>
                </div>
              </Grid>
            </Grid>
          </Headroom>

          <Grid item xs={12} sm={12} xl={12}>
            <Card
              bordered={false}
              style={{
                overflow: "auto",
                /* Other styles */
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#356F60 transparent", // thumb color and track color
                "&::-webkit-scrollbar": {
                  width: 8 /* Width of vertical scrollbar */,
                  height: 8 /* Height of horizontal scrollbar */,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#356F60" /* Color of the thumb */,
                  borderRadius: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent" /* Color of the track */,
                },
                /* Adjust the width for the horizontal scrollbar */
                "&::-webkit-scrollbar-thumb:horizontal": {
                  width: 4 /* Width of horizontal scrollbar */,
                },
                // zIndex: "10",

                height: "80vh",
              }}
            >
              <Prior_auth
                Dos={Dos}
                callingFromAuthoriazation={"CPT"}
                Source={"AuthorizationFormByCPT"}
                columnID={columnIDICD}
                PriorPracticeID={AuthPracticeId}
                CreatedDate={CreatedDate}
                CreatedBy={CreatedBy}
                PatientIdOfdemographics={patientId}
                DateofSubmission={Submissiondate}
                handleClose4={handlecloseapprovecpt}
                patientNameee={patientNameicd}
                AutpattientID1={AutpattientIcd}
                Markaporoved={Markaporoved}
                updateHealthHistory={(id, authId, authCPTId) => {
                  setValue("approved", true);
                  setColumnIDICD(authCPTId);
                }}
                style={{ height: "40vh" }}
              ></Prior_auth>
            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Grid>
        </Box>
      </Modal>
      {openModal ? (
        <>
          <Grid
            container
            xs={12}
            spacing={1}
            style={{
              marginTop: "50px",
              borderRadius: "20px",
              border: "1px solid rgba(5, 152, 236, 0.637)",
              overflow: "scroll",
            }}
          >
            <Grid container>
              <Grid item xs={0.3}></Grid>

              <Grid item xs={11.2}>
                {patientId > 0 ? (
                  <></>
                ) : (
                  <>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      style={{ marginTop: "2rem" }}
                    >
                      {" "}
                      Add Authorization
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid item xs={0.5}></Grid>
            </Grid>

            <Grid
              container
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                width: "100%",
                marginTop: "1px",
                borderRadius: "20px",
                height: "40px",
              }}
              bgcolor={"#356F60"}
            >
              <Grid item xs={1.5}>
                <Button
                  className="Button"
                  onClick={handleCloseModal}
                  variant="contained"
                  color="info"
                  size="small"
                  style={{
                    width: "20px",
                    float: "left",
                    marginLeft: "15px",
                    //  marginRight: '10px',
                    height: "23px",
                    marginTop: "8px",
                    //  backgroundColor:'#E87426'
                  }}
                >
                  <ArrowBackIosIcon
                    fontSize="medium"
                    style={{
                      color: "#1a82ad",

                      //  padding: "5px",
                      //  marginLeft: '5px'
                    }}
                  ></ArrowBackIosIcon>
                  Back
                </Button>
              </Grid>

              <Grid item xs={3}>
                <Typography
                  style={{
                    color: "white",
                    marginTop: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Patient Name:
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography style={{ color: "white", marginTop: "8px" }}>
                  {patientName}
                </Typography>
              </Grid>

              <Grid item xs={0.5}>
                <Typography
                  style={{
                    color: "white",
                    marginTop: "8px",
                    float: "right",
                    fontWeight: "bold",
                  }}
                >
                  ID:
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography style={{ color: "white", marginTop: "8px" }}>
                  {columnID}
                </Typography>
              </Grid>
              <Grid item xs={2.8}></Grid>
            </Grid>
            <Grid item xs={12}>
              <AuthorizationRegistration
                callingFrom={"Patient"}
                FormCall={props.FormCall}
                    setResetTab={props.setResetTab}
                   ResetTab={props.ResetTab}
                columnID={columnID}
                setAuthId={setAuthId}
                AutpattientID={
                  props.callingFrom === "dashboard"
                    ? props.AutpattientID
                    : AutpattientID
                }
                patientName={
                  props.callingFrom === "dashboard"
                    ? props.Dashboard
                    : patientName
                }
                patientId={patientId}
                Charge1={Charge1}
                CloseModal={handleCloseModal}
              ></AuthorizationRegistration>
            </Grid>
          </Grid>
        </>
      ) : openModaltmd ? (
        <>
          <>
            <Grid
              container
              xs={12}
              spacing={1}
              style={{
                marginTop: "50px",
                borderRadius: "20px",
                border: "1px solid rgba(5, 152, 236, 0.637)",
                overflow: "scroll",
              }}
            >
              <Grid container>
                <Grid item xs={0.3}></Grid>

                <Grid item xs={11.2}>
                  {patientId > 0 ? (
                    <></>
                  ) : (
                    <>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        style={{ marginTop: "2rem" }}
                      >
                        {" "}
                        Temporomandibular Disorders (TMD)
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid item xs={0.5}></Grid>
              </Grid>

              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  width: "100%",
                  marginTop: "1px",
                  borderRadius: "20px",
                  height: "40px",
                }}
                bgcolor={"#356F60"}
              >
                <Grid item xs={10.5}>
                  <Button
                    className="Button"
                    onClick={handleCloseModaltmd}
                    variant="contained"
                    color="info"
                    size="small"
                    style={{
                      width: "20px",
                      float: "left",
                      marginLeft: "15px",
                      //  marginRight: '10px',
                      height: "23px",
                      marginTop: "8px",
                      //  backgroundColor:'#E87426'
                    }}
                  >
                    <ArrowBackIosIcon
                      fontSize="medium"
                      style={{
                        color: "#1a82ad",
                        //  padding: "5px",
                        //  marginLeft: '5px'
                      }}
                    ></ArrowBackIosIcon>
                    Back
                  </Button>
                </Grid>
                <Grid item xs={0.5}>
                  <Typography
                    style={{
                      color: "white",
                      marginTop: "8px",
                      float: "right",
                      fontWeight: "bold",
                    }}
                  >
                    ID:
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography style={{ color: "white", marginTop: "8px" }}>
                    {columnIDTMD}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Tmdform
                  PatientdateTMD={PatientdateTMD}
                  callingFrom={"Patient"}
                  columnID={columnIDTMD}
                  patientId={patientId}
                  AutpattientID={AutpattientID}
                  patientNametmd={patientNametmd}
                  CloseModal={handleCloseModaltmd}
                ></Tmdform>
              </Grid>
            </Grid>
          </>
        </>
      ) : openModalicd ? (
        <>
          <>
            <Grid
              container
              xs={12}
              spacing={1}
              style={{
                marginTop: "50px",
                borderRadius: "20px",
                border: "1px solid rgba(5, 152, 236, 0.637)",
                overflow: "scroll",
              }}
            >
              {/* Authorization Registration Header (only if patientId is not set) */}
              {patientId <= 0 && (
                <Grid container justifyContent="center">
                  <Grid item xs={12} sm={10} md={8}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      sx={{
                        mt: 4,
                        textAlign: "center",
                        letterSpacing: 0.5,
                      }}
                    >
                      Authorization Registration
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {/* Top Bar with Back Button, Title and ID */}
              <Grid
                container
                alignItems="center"
                sx={{
                  width: "100%",
                  mt: 2,
                  px: 2,
                  py: 1.5,
                  borderRadius: 3,
                  backgroundColor: "#356F60",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                {/* Back Button */}
                <Grid
                  item
                  xs={12}
                  sm={4}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Button
                    onClick={handleCloseModalicd}
                    variant="contained"
                    size="small"
                    startIcon={<ArrowBackIosIcon fontSize="small" />}
                    className="Button"
                  >
                    Back
                  </Button>
                </Grid>

                {/* Center Title */}
                <Grid item xs={12} sm={4}>
                  <Typography
                    sx={{
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "1.1rem",
                    }}
                  >
                    VOB / Prior-auth
                  </Typography>
                </Grid>

                {/* ID Display */}
                <Grid item xs={12} sm={4}>
                  <Typography
                    sx={{
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "right",
                      pr: 2,
                      fontSize: "0.95rem",
                    }}
                  >
                    ID: {columnIDICD}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <AuthorizationFormByCPT
                  columnID={columnIDICD}
                  Charge={Charge}
                  Charge1={Charge1}
                  approvedcpt={approvedcpt}
                  patientId={patientId}
                  AutpattientIcd={AutpattientIcd1}
                  patientNametmd={patientNameicd1}
                  CloseModal={handleCloseModalicd}
                ></AuthorizationFormByCPT>
              </Grid>
            </Grid>
          </>
        </>
      ) : (
        <>
          {patientId > 0 ? (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <Typography style={{ color: "black", fontSize: "18px" }}>
                        Type:
                      </Typography>

                      <Controller
                        name="procedureCode1"
                        // {...register("procedureCode1")}
                        control={control}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            fullWidth
                            value={procedureCode1List.filter(function (option) {
                              return option.value == Charge1;
                            })}
                            onChange={(e) => {
                              setValue("procedureCode1", e.value);
                              setCharge1(e.qasim);
                              setCharge(e.charges);
                              settypeOfprocedureCode1(e.value);

                              setProcedureCode1ID(e.value);
                            }}
                            // styles={{ control: provided => ({ ...provided, width: '120px' }) }}
                            options={procedureCode1List}
                          />
                        )}
                      />
                    </Grid>
                    {procedureCode1ID !== "21085" && (
                      <Grid item xs={12} sm={5} md={5} lg={3}>
                        <Typography
                          style={{ color: "black", fontSize: "18px" }}
                        >
                          Status:
                        </Typography>
                        <ReactSelect
                          fullWidth
                          options={statusOptions}
                          value={statusOptions.find(
                            (option) => option.value === ApproveRequests
                          )}
                          onChange={handleStatusChange}
                        />
                      </Grid>
                    )}
                    <Grid item xs={0.5} style={{ display: "flex" }}></Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ display: "flex", marginTop: "21px" }}
                    >
                      {procedureCode1ID == "21085" &&
                      rights.Add_Authoriazation ? (
                        <>
                          <Button
                            className="Button"
                            variant="contained"
                            onClick={handleOpentmd}
                            style={{
                              float: "right",
                              height: "35px",
                              marginRight: "3px",
                            }}
                          >
                            <AddOutlinedIcon
                              fontSize="small"
                              style={{
                                color: "white",
                              }}
                            ></AddOutlinedIcon>
                            Add New
                          </Button>
                        </>
                      ) : (
                        <>
                          {procedureCode1ID == "E0486" &&
                          rights.Add_Authoriazation ? (
                            <>
                              <Button
                                className="Button"
                                variant="contained"
                                onClick={handleOpen1}
                                style={{
                                  float: "right",
                                  height: "35px",
                                  marginRight: "3px",
                                }}
                              >
                                <AddOutlinedIcon
                                  fontSize="small"
                                  style={{
                                    color: "white",
                                  }}
                                ></AddOutlinedIcon>
                                Add New
                              </Button>
                            </>
                          ) : (
                            <>
                              {rights.Add_Authoriazation && (
                                <Button
                                  className="Button"
                                  variant="contained"
                                  onClick={handleOpenicd}
                                  style={{
                                    float: "right",
                                    height: "35px",
                                    marginRight: "3px",
                                  }}
                                >
                                  <AddOutlinedIcon
                                    fontSize="small"
                                    style={{
                                      color: "white",
                                    }}
                                  ></AddOutlinedIcon>
                                  Add New
                                </Button>
                              )}
                            </>
                          )}
                        </>
                      )}

                      <Button
                        className="Button"
                        variant="contained"
                        style={{ height: "35px" }}
                        onClick={(event) => {
                          applyRefresh();
                        }}
                        //  style={{ marginLeft: '1rem',float:'right',marginRight:'0.5rem',   marginTop:'0.5rem'}}
                      >
                        <CachedOutlinedIcon
                          fontSize="small"
                          style={{
                            color: "white",
                          }}
                        ></CachedOutlinedIcon>
                        Refresh
                      </Button>
                    </Grid>
                  </Grid>
                  <>
                    {procedureCode1ID == "21085" ? (
                      <>
                        <Box mb={3} marginTop={2}>
                          {isLoading ? (
                            <div
                              style={{ margin: "5rem", textAlign: "center" }}
                            >
                              <CircularProgress />
                            </div>
                          ) : (
                            <div style={{ height: 400, width: "100%" }}>
                              {tmdrows === null || tmdrows.length === 0 ? (
                                <Typography>No Record found</Typography>
                              ) : (
                                <DataGrid
                                  rows={tmdrows}
                                  columns={tmdcolumns}
                                  sx={gridRowStyle}
                                  pagination
                                  pageSizeOptions={[25]}
                                  rowHeight={30}
                                  initialState={{
                                    pagination: {
                                      paginationModel: {
                                        pageSize: 100,
                                        page: 0,
                                      },
                                    },
                                  }}
                                />
                              )}
                            </div>
                          )}
                        </Box>
                      </>
                    ) : (
                      <>
                        {procedureCode1ID == "E0486" ? (
                          <>
                            <Box mb={3} marginTop={2}>
                              {isLoading ? (
                                <div
                                  style={{
                                    margin: "5rem",
                                    textAlign: "center",
                                  }}
                                >
                                  <CircularProgress />
                                </div>
                              ) : (
                                <div style={{ height: 400, width: "100%" }}>
                                  {rows === null || rows.length === 0 ? (
                                    <Typography>No Record found</Typography>
                                  ) : (
                                    <DataGrid
                                      rows={rows}
                                      // rows={[...new Map(rows.map((item) => [item.id, item])).values()]}
                                      columns={columns}
                                      pagination
                                      pageSizeOptions={[25]}
                                      sx={gridRowStyle}
                                      rowHeight={30}
                                      initialState={{
                                        pagination: {
                                          paginationModel: {
                                            pageSize: 100,
                                            page: 0,
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box mb={3} marginTop={2}>
                              {isLoading ? (
                                <div
                                  style={{
                                    margin: "5rem",
                                    textAlign: "center",
                                  }}
                                >
                                  <CircularProgress />
                                </div>
                              ) : (
                                <div style={{ height: 400, width: "100%" }}>
                                  {Cptsrows === null ||
                                  Cptsrows.length === 0 ? (
                                    <Typography>No Record found</Typography>
                                  ) : (
                                    <DataGrid
                                      rows={Cptsrows}
                                      columns={cptcolumns}
                                      pagination
                                      pageSizeOptions={[25]}
                                      sx={gridRowStyle}
                                      rowHeight={30}
                                      initialState={{
                                        pagination: {
                                          paginationModel: {
                                            pageSize: 100,
                                            page: 0,
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </Box>
                          </>
                        )}
                      </>
                    )}
                  </>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid container className="page-content">
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Typography
                        style={{
                          color: "black",
                          fontSize: "18px",
                          marginTop: "10px",
                        }}
                      >
                        Type:
                      </Typography>
                      <Controller
                        name="procedureCode1"
                        // {...register("procedureCode1")}
                        control={control}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            fullWidth
                            value={procedureCode1List.filter(function (option) {
                              return option.value == Charge1;
                            })}
                            onChange={(e) => {
                              setValue("procedureCode1", e.value);
                              setCharge1(e.qasim);
                              setCharge(e.charges);
                              settypeOfprocedureCode1(e.value);

                              setProcedureCode1ID(e.value);
                            }}
                            // styles={{ control: provided => ({ ...provided, width: '120px' }) }}
                            options={procedureCode1List}
                          />
                        )}
                      />
                    </Grid>

                    {procedureCode1ID !== "21085" && (
                      <Grid item xs={12} sm={5} md={5} lg={3}>
                        <Typography
                          style={{
                            color: "black",
                            fontSize: "18px",
                            marginTop: "10px",
                          }}
                        >
                          Status:
                        </Typography>
                        <ReactSelect
                          fullWidth
                          options={statusOptions}
                          value={statusOptions.find(
                            (option) => option.value === ApproveRequests
                          )}
                          onChange={handleStatusChange}
                        />
                      </Grid>
                    )}

                    {/* <Grid item xs={3}  >
                    </Grid> */}

                    <Grid item xs={3} style={{ marginTop: "1.7rem" }}>
                      <div style={{ display: "flex", height: "27px" }}>
                        {rights.AllPractice_Authoraization && (
                          <>
                            <Checkbox
                              value={isAllPractics}
                              style={{ marginTop: "20px" }}
                              onChange={(e) => {
                                setisAllPractics(e.target.checked);
                              }}
                            />
                            <Typography
                              style={{
                                marginLeft: "10px",
                                marginTop: "15px",
                                fontWeight: "bold",
                              }}
                            >
                              All Practices
                            </Typography>
                          </>
                        )}
                      </div>
                    </Grid>

                    <Grid item spacing={1} xs={12} sm={12} md={12} lg={12}>
                      {procedureCode1ID == "21085" &&
                      rights.Add_Authoriazation ? (
                        <>
                          <Button
                            className="Button"
                            variant="contained"
                            onClick={handleOpentmd}
                            style={{ float: "right", marginTop: "9px" }}
                          >
                            <AddOutlinedIcon
                              fontSize="small"
                              style={{
                                color: "white",
                                paddingRight: "4px",
                                paddingBottom: "2px",
                              }}
                            ></AddOutlinedIcon>
                            Add New
                          </Button>
                        </>
                      ) : (
                        <>
                          {procedureCode1ID == "E0486" &&
                          rights.Add_Authoriazation ? (
                            <>
                              <Button
                                className="Button"
                                variant="contained"
                                onClick={handleOpen1}
                                style={{ float: "right", marginTop: "9px" }}
                              >
                                <AddOutlinedIcon
                                  fontSize="small"
                                  style={{
                                    color: "white",

                                    paddingRight: "4px",
                                    paddingBottom: "2px",
                                  }}
                                ></AddOutlinedIcon>
                                Add New
                              </Button>
                            </>
                          ) : (
                            <>
                              {rights.Add_Authoriazation && (
                                <Button
                                  className="Button"
                                  variant="contained"
                                  onClick={handleOpenicd}
                                  style={{ float: "right", marginTop: "10px" }}
                                >
                                  <AddOutlinedIcon
                                    fontSize="small"
                                    style={{
                                      color: "white",

                                      paddingRight: "4px",
                                      paddingBottom: "2px",
                                    }}
                                  ></AddOutlinedIcon>
                                  Add New
                                </Button>
                              )}
                            </>
                          )}
                        </>
                      )}

                      <Button
                        className="Button"
                        variant="contained"
                        onClick={(event) => {
                          applyRefresh();
                        }}
                        style={{
                          marginLeft: "1rem",
                          float: "right",
                          marginRight: "25px",
                          marginTop: "10px",
                        }}
                      >
                        <CachedOutlinedIcon
                          fontSize="small"
                          style={{
                            color: "white",
                            paddingRight: "0px",
                            paddingBottom: "1px",
                          }}
                        ></CachedOutlinedIcon>
                        Refresh
                      </Button>
                    </Grid>
                  </Grid>
                  <>
                    {procedureCode1ID == "21085" ? (
                      <>
                        <Box mb={3} marginTop={2}>
                          {isLoading ? (
                            <div
                              style={{ margin: "5rem", textAlign: "center" }}
                            >
                              <CircularProgress />
                            </div>
                          ) : (
                            <div style={{ height: 400, width: "100%" }}>
                              {tmdrows === null || tmdrows.length === 0 ? (
                                <Typography>No Record found</Typography>
                              ) : (
                                <DataGrid
                                  rows={tmdrows}
                                  columns={tmdcolumns}
                                  pagination
                                  pageSizeOptions={[25]}
                                  sx={gridRowStyle}
                                  rowHeight={30}
                                  initialState={{
                                    pagination: {
                                      paginationModel: {
                                        pageSize: 100,
                                        page: 0,
                                      },
                                    },
                                  }}
                                />
                              )}
                            </div>
                          )}
                        </Box>
                      </>
                    ) : (
                      <>
                        {procedureCode1ID == "E0486" ? (
                          <>
                            <Box mb={3} marginTop={2}>
                              {isLoading ? (
                                <div
                                  style={{
                                    margin: "5rem",
                                    textAlign: "center",
                                  }}
                                >
                                  <CircularProgress />
                                </div>
                              ) : (
                                <div style={{ height: 400, width: "100%" }}>
                                  {rows === null || rows.length === 0 ? (
                                    <Typography>No Record found</Typography>
                                  ) : (
                                    <DataGrid
                                      rows={rows}
                                      // rows={[...new Map(rows.map((item) => [item.id, item])).values()]}
                                      columns={columns}
                                      pagination
                                      pageSizeOptions={[25]}
                                      sx={gridRowStyle}
                                      rowHeight={30}
                                      initialState={{
                                        pagination: {
                                          paginationModel: {
                                            pageSize: 100,
                                            page: 0,
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box mb={3} marginTop={2}>
                              {isLoading ? (
                                <div
                                  style={{
                                    margin: "5rem",
                                    textAlign: "center",
                                  }}
                                >
                                  <CircularProgress />
                                </div>
                              ) : (
                                <div style={{ height: 400, width: "100%" }}>
                                  {Cptsrows === null ||
                                  Cptsrows.length === 0 ? (
                                    <Typography>No Record found</Typography>
                                  ) : (
                                    <DataGrid
                                      rows={Cptsrows}
                                      columns={cptcolumns}
                                      pagination
                                      pageSizeOptions={[25]}
                                      sx={gridRowStyle}
                                      rowHeight={30}
                                      initialState={{
                                        pagination: {
                                          paginationModel: {
                                            pageSize: 100,
                                            page: 0,
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </Box>
                          </>
                        )}
                      </>
                    )}
                  </>
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Authorization;
